<template>
  <div class="w-90">
    <b-card bg-variant="light">
      <h1 id="jump-to-header">{{heading || generated_heading}}</h1>
      <b-tabs
        active-nav-item-class="font-weight-bold text-uppercase text-warning"
        active-tab-class="font-weight-bold text-success"
        content-class="mt-3"
        lazy
      >
        <b-tab title="Settings" active>
          <product-model-update :id="id" @gotAttrs="assignAttrs"/>
        </b-tab>
        <b-tab title="Product Listings">
          <product-listing-index
            :filtering="filtering"
            :ams_template="ams_template"
          ></product-listing-index>
        </b-tab>
        <b-tab title="Information">
          <polymorphic-reference-index
            :filtering="filtering_reference"
            :ams_template="ams_template_reference"
          ></polymorphic-reference-index>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import ProductModelUpdate from './ProductModelUpdate.vue'
import ProductListingIndex from './ProductListingIndex.vue'
import PolymorphicReferenceIndex from './PolymorphicReferenceIndex.vue'

export default {
  components: {
    ProductModelUpdate,
    ProductListingIndex,
    PolymorphicReferenceIndex
  },
  props: {
    id: String,
    heading: {
      Type: String
    }
  },
  data () {
    return {
      generated_heading: undefined,
      filtering: {
        product_model_ids: this.id
      },
      ams_template: {
        type: 'product-listings',
        description: undefined,
        attributes: {
          'product-model-id': this.id,
          'price-cents': 0
        }
      },
      filtering_reference: {
        reference_to_type: 'ProductModel',
        reference_to_id: this.id
      },
      ams_template_reference: {
        type: 'polymorphic-references',
        descrition: undefined,
        attributes: {
          'reference-to-type': "ProductModel",
          'reference-to-id': this.id
        }
      },
      attrs: {},
    }
  },
  methods: {
    assignAttrs(attrs, description) {
      this.generated_heading = description
      this.attrs = Object.assign( {}, attrs)
      this.ams_template.description = description + attrs['name']
    }
  },
  mounted() {
    const element = document.getElementById("jump-to-header")
    element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
  }
}
</script>